import { jsx as _jsx } from "react/jsx-runtime";
import { Dropdown } from "antd";
import classNames from "classnames";
import { isValidElement } from "react";
import { Tooltip } from "../common/tooltip.js";
const ToolbarButton = ({ visible = true, content, cssClasses, toolTipTitle, toolTipText, disabled, menu, toolTipPlacement, dropdownPlacement, modifier, onClick, ...restProps })=>{
    const props = {
        visible,
        content,
        cssClasses,
        toolTipTitle,
        toolTipText,
        disabled,
        menu,
        toolTipPlacement,
        dropdownPlacement,
        modifier,
        onClick,
        ...restProps
    };
    const handleClick = (e)=>{
        if (!disabled) {
            onClick?.(props);
        }
        e.preventDefault();
    };
    if (!visible) {
        return null;
    }
    const className = classNames(cssClasses, "aiot-tooltip", {
        "aiot-disabled": disabled
    });
    let body = /*#__PURE__*/ _jsx("a", {
        href: "#",
        className: className,
        "aria-disabled": disabled,
        onClick: handleClick,
        children: content
    });
    if (modifier) {
        body = modifier(body, props);
    }
    if (toolTipTitle && toolTipText) {
        body = /*#__PURE__*/ _jsx(Tooltip, {
            placement: toolTipPlacement ?? (menu ? "rightTop" : "bottom"),
            title: toolTipTitle,
            content: toolTipText,
            children: body
        });
    }
    if (menu) {
        const resolvedMenu = typeof menu === "function" ? menu() : menu;
        const dropdownTrigger = /*#__PURE__*/ _jsx("span", {
            className: "aiot-toolbar-dropdown-trigger",
            children: body
        });
        if (/*#__PURE__*/ isValidElement(resolvedMenu)) {
            body = /*#__PURE__*/ _jsx(Dropdown, {
                placement: dropdownPlacement ?? "bottomRight",
                popupRender: ()=>resolvedMenu,
                children: dropdownTrigger
            });
        } else {
            let menuProps;
            if (Array.isArray(resolvedMenu)) {
                menuProps = {
                    items: resolvedMenu.map(({ key, label, toolTipTitle: itemTitle, toolTipText: itemText, ...itemRest })=>({
                            key,
                            label: itemTitle && itemText ? /*#__PURE__*/ _jsx(Tooltip, {
                                classNames: {
                                    root: "aiot-toolbar-menu"
                                },
                                placement: "rightTop",
                                title: itemTitle,
                                content: itemText,
                                children: /*#__PURE__*/ _jsx("span", {
                                    children: label
                                })
                            }) : label,
                            ...itemRest
                        }))
                };
            }
            body = /*#__PURE__*/ _jsx(Dropdown, {
                placement: dropdownPlacement ?? "bottomRight",
                menu: menuProps ?? {
                    items: resolvedMenu
                },
                children: dropdownTrigger
            });
        }
    }
    return body;
};
export { ToolbarButton };
